import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { customerApi } from "@/lib/api";

const Ctx = createContext(null);
export const useCustomerAuth = () => useContext(Ctx);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null); // null=checking, false=guest, obj=signed in

  const check = useCallback(() => {
    if (!localStorage.getItem("acp_customer_token")) { setCustomer(false); return; }
    customerApi.get("/customer/me").then((r) => setCustomer(r.data)).catch(() => {
      localStorage.removeItem("acp_customer_token"); setCustomer(false);
    });
  }, []);

  useEffect(() => {
    // Returning from Google OAuth — AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) return;
    check();
  }, [check]);

  const setSession = (token, cust) => { localStorage.setItem("acp_customer_token", token); setCustomer(cust); };

  const login = async (email, password) => {
    const { data } = await customerApi.post("/customer/login", { email, password });
    setSession(data.token, data.customer);
    return data.customer;
  };
  const register = async (payload) => {
    const { data } = await customerApi.post("/customer/register", { ...payload, base_url: window.location.origin });
    setSession(data.token, data.customer);
    return data.customer;
  };
  const logout = () => { localStorage.removeItem("acp_customer_token"); setCustomer(false); };
  const refresh = () => customerApi.get("/customer/me").then((r) => setCustomer(r.data)).catch(() => {});

  return (
    <Ctx.Provider value={{ customer, setCustomer, setSession, login, register, logout, refresh }}>
      {children}
    </Ctx.Provider>
  );
}
